export default "__VITE_ASSET__C$W8j9SY__"